/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "aa4111176e0ae154abf564aa78e31b6512c9a22e";
